import * as settings from '@/settings';
import request from '@/Utils/Request';

export async function apiGetVerificationimg() {
  return request.get('/api/login/captcha?t=' + (new Date()).getTime());
}

export async function apiLogin(reqData) {
  return request.post('/api/login', reqData);
}

export async function apiGetUserInfo() {
  return request.get('/api/user/me');
}

export async function apiGetUserInfoWithRedirt() {
  return request.get('/api/user/me/login');
}

export async function apiGetProjects() {
  return request.get('/api/user/projects', {
    params: {
      cursor: 0,
      count: settings.MaxPageCount
    }
  });
}

export async function apiGetProjectApps(projectId) {
  return request.get(`/api/user/apps/${projectId}`, {
    params: {
      cursor: 0,
      count: settings.MaxPageCount
    }
  });
}

export async function apiGetAppLog(data) {
  return request.get(`/api/project/event/${data.projectId}`, {
    params: {
      start: data.startDate,
      end: data.endDate,
      cursor: data.cursor,
      count: data.count
    }
  });
}

export async function apiGetProjectTags(projectId) {
  return request.get(`/api/project/tags/${projectId}`);
}

export async function apiSwitchApp(appid) {
  return request.post(`/api/app/stop/${appid}`);
}

export async function apiSortPriority(projectId, data) {
  return request.post(`/api/app/priority/${projectId}`, data);
}

export async function apiSortReduction(projectId, pid) {
  return request.get(`/api/project/reset/priority/${projectId}?platform=${pid}`);
}

export async function apiGetStorageData(projectId) {
  return request.get(`/api/storage/search/${projectId}`);
}

export async function apiGetUserUploadKey(projectId) {
  return request.get(`/api/user/uploadkey/${projectId}`);
}

export async function apiCreateApp(data) {
  return request.post("/api/app/create", data);
}

export async function apiGetAppDetail(appid) {
  return request.get(`/api/app/detail/${appid}`);
}

export async function apiDeleteApp(appid) {
  return request.delete(`/api/app/delete/${appid}`);
}

export async function apiModifyApp(data) {
  return request.post('/api/app/modify', data);
}

export async function apiUploadImage(data) {
  return request.post("/api/app/image/upload", data);
}

export async function apiDeleteVersion(data) {
  return request.delete("/api/app/version/delete", { data });
}

export async function apiModifyVersionTags(data) {
  return request.post("/api/app/version/tags/add", data);
}

export async function apiClosureVersion(projectId, appid) {
  return request.delete(`/api/app/version/closure/${projectId}/${appid}`);
}

export async function apiReleaseVersion(appid) {
  return request.put(`/api/app/version/release/${appid}`);
}

export async function apiModifyReleaseNote(versionId, data) {
  return request.post(`/api/app/version/releasenote/${versionId}`, data);
}

export async function apiShareVersion(projectId, appid) {
  return request.post(`/api/app/version/participation/${projectId}/${appid}`);
}

export async function apiGetAppVersions(appid, params) {
  return request.get(`/api/app/version/${appid}`, { params });
}
export async function apiGetVersionSerch(data) {
  return request.post(`/api/app/version/search`, data);
}

export async function apiGetAppInfoByUri(uri) {
  return request.get('/service/app/version/uri', { params: { uri } });
}

export async function apiGetApplePackageUrlForComputer(appid, versionId, data) {
  return request.post(`/service/app/ipa/${appid}/${versionId}`, data);
}

export async function apiGetPackageUrl(data) {
  return request.post('/service/app/version/url', data);
}

export async function apiGetStorageDelete(data) {
  return request.delete(`/api/storage/delete`, { data });
}

export async function apiGetAppAllVersions(data) {
  return request.post(`/api/app/multisearch/version`, data);
}

export async function apiGetTesterProjectApps(cursor, count, pid) {
  return request.get('/api/user/taskapps', { params: { cursor, count, pid } });
}

export async function apiGetAnalysisData(startDate, endDate) {
  return request.get(`/api/project/scan/size?start=${startDate}&end=${endDate}`);
}

export async function apiGetActivityList(projectId, params) {
  return request.get(`/api/project/activity/${projectId}`, { params });
}

export async function apiGetTestGroups(projectId) {
  return request.get(`/api/testers/groups/${projectId}`, {
    params: {
      cursor: 0,
      count: settings.MaxPageCount
    }
  });
}

export async function apiGetTestUsers(projectId) {
  return request.get(`/api/testers/invitations/${projectId}`, {
    params: {
      cursor: 0,
      count: settings.MaxPageCount
    }
  });
}

export async function apiGetActivityCategory(projectId) {
  return request.get(`/api/project/activity/${projectId}/categories`);
}

export async function apiModifyActivity(projectId, data) {
  return request.post(`/api/project/activity/${projectId}/modify`, data);
}

export async function apiNewActivity(projectId, data) {
  return request.post(`/api/project/activity/${projectId}/create`, data);
}

export async function apiGetActivityShareInfo(uri) {
  return request.get(`/service/activity/share/${uri}`);
}

export async function apiGetKoaUserList() {
  return request.get('/api/user/list');
}

export async function apiAddTester(data) {
  return request.post('/api/testers/invitations/create', data);
}

export async function apiModifyTester(data) {
  return request.post('/api/testers/invitations/modify', data);
}

export async function apiDeleteTester(data) {
  return request.delete('/api/testers/invitations/delete', { data });
}

export async function apiAddTestGroup(data) {
  return request.post("/api/testers/group/create", data);
}

export async function apiModifyTestGroup(data) {
  return request.post("/api/testers/group/modify", data);
}

export async function apiDeleteTestGroup(data) {
  return request.delete('/api/testers/group/delete', { data });
}

export async function apiPackageParseDependency(params) {
  return request.get('/service/packageparse/dependency', { params });
}

export async function apiPackageParseAsset(params) {
  return request.get('/service/packageparse/asset', { params });
}

export async function apiPackageParseBoundle(type, params) {
  let url = "";
  if (type === 'toobigbundle') { url = '/service/packageparse/toobigbundle'; }
  else if (type === "circlebundle") { url = '/service/packageparse/circlebundle'; }
  else { url = '/service/packageparse/bundle'; }
  return request.get(url, { params });
}

export async function apiPackageParseAssetsuffix(params) {
  return request.get('/service/packageparse/assetsuffix', { params });
}

export async function apiPackageParseGraph(params) {
  return request.get('/service/packageparse/graph', { params });
}

export async function apiPackageParseBundleBetweenAsset(params) {
  return request.get('/service/packageparse/bundlebetweenasset', { params });
}

export async function apiPackageParseOverview(params) {
  return request.get('/service/packageparse/overview', { params });
}

export async function apiPackageParseFulltext(params) {
  return request.get('/service/packageparse/fulltext', { params });
}

export async function apiPackageParseScene(params) {
  return request.get('/service/packageparse/scene', { params });
}

export async function apiPackageParseDiagramSuffix(data) {
  return request.post('/service/packageparse/diagram/suffix', data);
}

export async function apiPackageParseDiagram(data) {
  return request.post('/service/packageparse/diagram', data);
}

export async function apiPackageParseVersionList(appid) {
  return request.get(`/service/packageparse/versionList/${appid}`);
}

export async function apiPackageParseTemporary(appid) {
  return request.get(`/service/packageparse/temporary/list/${appid}`);
}

export async function apiResourceUrl(data) {
  return request.post('/api/resource/verify', data);
}

export async function apiResourceNotify(data) {
  return request.post('/api/resource/notify', data);
}

export async function apiResoueceList(params) {
  return request.get('/api/resource/list', { params });
}

export async function apiResoueceDownload(data) {
  return request.post('/api/resource/download', data);
}

export async function apiResourceRemove(data) {
  return request.post('/api/resource/remove', data);
}

export async function apiProjectModify(data) {
  return request.post('/api/project/modify', data);
}

export async function apiCreateCertificate(data) {
  return request.post('/api/project/create', data);
}

export async function apiGetCertificate(appid) {
  return request.get(`/api/certificate/list/${appid}`);
}

export async function apiGetTakoAnalysis() {
  return request.get('/api/stat/all/get');
}

export async function apiGetProjectLog(data) {
  return request.get('/api/event/all', {
    params: {
      start: data.startDate,
      end: data.endDate,
      cursor: data.cursor,
      count: data.count
    }
  });
}

export async function apiGetCertificateAll() {
  return request.get('/api/all/certificate/list', {
    params: {
      cursor: 0,
      count: settings.MaxPageCount
    }
  });
}

export async function apiUploadBackImage(data) {
  return request.post("/api/app/backimage/upload", data);
}